import React, { useContext, useEffect, useState } from "react";
import { BoxWrapper } from "../../../style";
import arrowIcon from "../../../images/arrow.png";
import { FormWrapper2 } from "../../../components/loan/style";
import Button from "../../../components/ui/Button";
import Alert from "../../../components/ui/Alert";
import { useNavigate } from "react-router-dom";
import { getStorage, goBack, setStorage } from "../../../Utils/common";
import PictureUpload from "../../../components/PictureUpload/PictureUpload";
import { saveDocuments, requiredDocs } from "../../../Utils/api";
import ContextDashboard from "../../../Context/ContextDashboard";

function DocumentUpload() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [documentsRequired, setDocumentsRequired] = useState([]);
  const [uploadedDocuments, setUploadedDocuments] = useState({});
  const [isLoadingDocs, setIsLoadingDocs] = useState(true); // Loading state for docs
  const navigate = useNavigate();
  const { logout, handleEvent } = useContext(ContextDashboard);

  // Fetch required documents when the component mounts
  useEffect(() => {
    const params = { profile_id: getStorage("cust_profile_id") || "" };
    setIsLoadingDocs(true); // Set loading state to true before API call
    requiredDocs(params).then(resp => {
      if (resp?.data?.Status === 1) {
        setDocumentsRequired(resp?.data?.Data || []);
        // setMessage({ type: 'success', msg: resp?.data?.Message, place:"globle" });
        setMessage({ type: 'success', msg: resp?.data?.Message, place: "globle" });
      } else {
        setMessage({ type: "error", msg: resp?.data?.Message });
      }
      setIsLoadingDocs(false); // Set loading state to false once data is fetched
    }).catch(err => {
      setMessage({ type: "error", msg: "Failed to fetch required documents." });
      setIsLoadingDocs(false); // Set loading state to false on error
    });
  }, []);

  // Handle file change (image or document)
  const handleFileChange = (docName, file) => {
    setUploadedDocuments(prev => ({ ...prev, [docName]: file }));
  };

  // Convert file to base64 for upload
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(",").pop());
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  // Submit the documents
  const submitDocuments = async () => {
    // Validation: Check if all required documents have been uploaded
    const missingDocuments = documentsRequired.filter(doc => !uploadedDocuments[doc.name]);
    if (missingDocuments.length > 0) {
      setMessage({ type: "error", msg: "Please upload all required documents." });
      return; // Stop the submission if there are missing documents
    }

    setLoading(true);
    const uploadPromises = [];

    for (const doc of documentsRequired) {
      const docName = doc.name;
      const file = uploadedDocuments[docName];

      if (file) {
        try {
          const base64File = await convertToBase64(file);
          const ext = file.name.split('.').pop().toUpperCase();
          const param = {
            profile_id: getStorage("cust_profile_id") || "",
            file_ext: ext,
            password: "N/A",
            event_name: doc.event_name,
            doc_type: doc.doc_type,
            file: base64File,
          };
          uploadPromises.push(saveDocuments(param));
        } catch (err) {
          setMessage({ type: "error", msg: `Failed to upload ${docName}. Please try again.` });
          setLoading(false);
          return;
        }
      }
    }

    try {
      const responses = await Promise.all(uploadPromises);
      const successResponses = responses.filter(resp => resp?.data?.Status === 1);

      if (successResponses.length === uploadPromises.length) {
        setMessage({ type: 'success', msg: 'All documents uploaded successfully', place: "global" });
        setStorage("next_step", successResponses[0]?.data?.Data?.next_step);
        setStorage('percent', successResponses[0]?.data?.Data?.step_percentage);
        handleEvent(getStorage('next_step'));
      } else {
        setMessage({ type: "error", msg: "Some documents failed to upload. Please try again." });
      }
    } catch (error) {
      setMessage({ type: "error", msg: "An error occurred while uploading documents. Please try again." });
    }

    setLoading(false);
  };

  return (
    <>

      <BoxWrapper className="w-full min-h-screen p-3 sm:p-5 md:p-8">
        <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl md:rounded-3xl shadow-lg p-4 sm:p-6 md:p-10">

          {/* Header */}
          <div className="flex flex-col sm:flex-row gap-5 sm:items-start">

            <div className="flex-1">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1D3557]">
                Upload Your Documents
              </h2>

              <p className="text-gray-500 mt-2 text-sm sm:text-base">
                Upload all the required documents to verify your details.
              </p>
            </div>

          </div>

          <FormWrapper2 className="mt-8">

            <Alert
              setMessage={setMessage}
              message={message}
            />

            {isLoadingDocs ? (

              <div className="flex justify-center items-center py-16">
                <p className="text-gray-500 text-lg">
                  Loading required documents...
                </p>
              </div>

            ) : documentsRequired.length > 0 ? (

              <div className=" flex flex-wrap gap-5 items-center ">

                {documentsRequired.map((doc) => (
                  <div key={doc.name}>

                    <h3 className="font-semibold text-lg text-[#1D3557] mb-4">
                      {doc.name}
                      <span className="text-red-500 ml-1">*</span>
                    </h3>

                    <PictureUpload
                      className="flex "
                      setImage={(file) => handleFileChange(doc.name, file)}
                      image={uploadedDocuments[doc.name] || ""}
                      accept={
                        doc.allowed_format === "image"
                          ? "image/*"
                          : "application/pdf"
                      }
                      type="file"
                    />

                  </div>
                ))}

              </div>

            ) : (

              <div className="text-center py-16">
                <p className="text-gray-500">
                  No documents are required at this moment.
                </p>
              </div>

            )}

            {!isLoadingDocs && documentsRequired.length > 0 && (

              <>
                {/* Security Card */}
                <div className="mt-8 border border-green-200 bg-green-50 rounded-2xl p-4 sm:p-5 flex gap-4 items-start">

                  <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-full shadow flex items-center justify-center shrink-0">
                    🔒
                  </div>

                  <div>
                    <h4 className="font-semibold text-base sm:text-lg text-[#1D3557]">
                      Your information is safe with us
                    </h4>

                    <p className="text-sm sm:text-base text-gray-600 mt-1">
                      All uploaded documents are securely encrypted and used only for verification.
                    </p>
                  </div>

                </div>

                {/* Button */}
                <div className="mt-8 w-full">
                  <Button
                    className="w-full bg-[#2D5F7A]"
                    title="Continue"
                    onClick={submitDocuments}
                    loading={loading}
                    disabled={loading || isLoadingDocs}
                  />
                </div>


              </>

            )}

          </FormWrapper2>

        </div>
      </BoxWrapper>

    </>
  );
}

export default DocumentUpload;